// extracted by mini-css-extract-plugin
export var table = "_wn-0";